// extracted by mini-css-extract-plugin
module.exports = {"table":"UserReportProjects_table__2Jaqc","title":"UserReportProjects_title__1BLXB"};